import sample_1 from './multiwear.jpg';

export const multiwearImpressions = {
    sample_1,
};
